module.exports = __webpack_public_path__ + "static/media/eventNew.36bdeed8.png";